var _circle, _circle2, _circle3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 114,
    viewBox: "0 0 119 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 57,
    r: 42,
    fill: "#C62B6D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 56.5,
    r: 3.5,
    fill: "#FEFEFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 56.5,
    r: 3.5,
    fill: "#FEFEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 40H42C40.3431 40 39 41.3431 39 43V69C39 70.6569 40.3431 72 42 72H52.2222",
    stroke: "#FEFEFF",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3725 40H81C82.6569 40 84 41.3431 84 43V69.5746C84 71.2314 82.6569 72.5746 81 72.5746H67.1344C66.0467 72.5746 65.0442 73.1633 64.5143 74.1133L59 84",
    stroke: "#FEFEFF",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/Chatbot.71728dc5206d341708d35115ab2fb858.svg";
export { ForwardRef as ReactComponent };